module.exports = __webpack_public_path__ + "static/media/icon_xiala.767dd2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_xiala.png
// module id = 2165
// module chunks = 0